import React from 'react';
import classNames from './MyClassesView.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import TeacherMyClassesStatistics from './TeacherMyClassesStatistics';

import Navbar from '@/components/Navbar/Navbar';

const MyClassesViewMobile = () => {
  const { t } = useTranslation();
  const { user } = useAppSelector(authSelector);

  return (
    <div className={classes(classNames.myClassesView, classNames.myClassesMobileView)}>
      <Navbar className={classNames.navbar}>
        <div id='my_classes_header' className={classNames.header}>
          <h2>{t('settings.my_classes')}</h2>
        </div>
      </Navbar>
      <div className={classNames.mobileStatsSection}>
        <p className={classNames.mobileDesktopMessage}>{t('teacherMobile.classesMessage')}</p>
        {user && (
          <TeacherMyClassesStatistics user={user} classFilters={{}} hasAnyClassFilter={false} />
        )}
      </div>
    </div>
  );
};

export default React.memo(MyClassesViewMobile);
